export enum GlassWasherStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export interface GlassWasherModel {
  id: string;
  venue: string;
  barId: string;
  status: GlassWasherStatusType;
  name: string;
  location: string;
  position: number;
  description: string | null;
  detergentPerLevel: number | null;
  rinsePerLevel: number | null;
}

export interface CreateGlassWasherParams {
  venueId: string | null;
  barId: string | null;
  status: GlassWasherStatusType;
  description: string | null;
  location: string | null;
  position: number | null;
  detergentPerLevel: number | null;
  rinsePerLevel: number | null;
  shouldShift: boolean | null;
}

export interface UpdateGlassWasherParams extends CreateGlassWasherParams {
  glassWasherId: string | null;
}

export interface ListGlassWashersResponse {
  result: GlassWasherModel[];
}

export interface DeleteGlassWasherParams {
  glassWasherId: string;
}

export interface ListGlassWashersResponse {
  result: GlassWasherModel[];
  limit: number;
  offset: number;
  count: number;
}

export type GlassWasherSortingFields = 'name' | 'detergentPerLevel' | 'rinsePerLevel' | 'status';
